import {
  WebPushConfigSchema,
  WebPushDeviceSchema,
  WebPushPreferencesSchema,
  WebPushTestResultSchema,
  type UpdateWebPushPreferencesRequest,
  type WebPushConfig,
  type WebPushDevice,
  type WebPushPreferences,
  type WebPushSubscribeRequest,
  type WebPushTestResult,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/** `/me/push/*` - the signed-in user's own devices and push settings. */

export const getPushConfig = async (): Promise<WebPushConfig> => {
  const { data } = await apiClient.get<unknown>('/me/push/config');
  return WebPushConfigSchema.parse(data);
};

export const registerPushSubscription = async (
  body: WebPushSubscribeRequest,
): Promise<WebPushDevice> => {
  const { data } = await apiClient.post<unknown>('/me/push/subscriptions', body);
  return WebPushDeviceSchema.parse(data);
};

export const removePushSubscription = async (endpoint: string): Promise<void> => {
  await apiClient.post('/me/push/subscriptions/remove', { endpoint });
};

export const listPushDevices = async (): Promise<WebPushDevice[]> => {
  const { data } = await apiClient.get<unknown>('/me/push/devices');
  return WebPushDeviceSchema.array().parse(data);
};

export const removePushDevice = async (id: string): Promise<void> => {
  await apiClient.delete(`/me/push/devices/${encodeURIComponent(id)}`);
};

export const getPushPreferences = async (): Promise<WebPushPreferences> => {
  const { data } = await apiClient.get<unknown>('/me/push/preferences');
  return WebPushPreferencesSchema.parse(data);
};

export const updatePushPreferences = async (
  patch: UpdateWebPushPreferencesRequest,
): Promise<WebPushPreferences> => {
  const { data } = await apiClient.patch<unknown>('/me/push/preferences', patch);
  return WebPushPreferencesSchema.parse(data);
};

export const sendTestPush = async (): Promise<WebPushTestResult> => {
  const { data } = await apiClient.post<unknown>('/me/push/test', {});
  return WebPushTestResultSchema.parse(data);
};
